import React, {useCallback, useState} from 'react';
import {useFocusEffect} from '@react-navigation/native';
import {useTheme} from 'styled-components/native';
import Feather from 'react-native-vector-icons/Feather';

import {
  Container,
  RescueHelperContainer,
  RescueHelperText,
  SectionBannerContainer,
  SectionHeader,
  SectionSubtitle,
  SectionTitleGroup,
  Title,
} from './styles';
import {BaratinhasDiscountBalloon} from '../../../../BaratinhasDiscountBalloon';
import {PaymentBaratinhasMethodItem} from '../../../PaymentBaratinhasMethodItem';
import {Platform} from 'react-native';
import {RFValue} from 'react-native-responsive-fontsize';
import { BaratinhasState } from '../../../../../../hooks/useBaratinhas';
import {api} from '../../../../../../services/api';
import {PodeResgatarBaratinhasDTO} from '../../../../../../dtos/PodeResgatarBaratinhasDTO';
import analytics from '@react-native-firebase/analytics';

type Props = Pick<
  BaratinhasState,
  | 'usaBaratinhas'
  | 'descontoBaratinhas'
  | 'handleAplicaBaratinhas'
  | 'handleRemoveBaratinhas'
  | 'handleSetDescontoBaratinhas'
>;

export function CheckoutBaratinhas({
  usaBaratinhas,
  descontoBaratinhas,
  handleAplicaBaratinhas,
  handleRemoveBaratinhas,
  handleSetDescontoBaratinhas,
}: Props) {
  const theme = useTheme();
  const [isLoading, setIsLoading] = useState(true);
  const [resgate, setResgate] = useState<PodeResgatarBaratinhasDTO | null>(
    null,
  );

  useFocusEffect(
    useCallback(() => {
      let isActive = true;

      async function fetchPodeResgatar() {
        try {
          setIsLoading(true);

          const {data} = await api.get<PodeResgatarBaratinhasDTO>(
            '/podeResgatar',
          );

          if (!isActive) {
            return;
          }

          setResgate(data);
        } catch (err) {
          console.log('Erro ao buscar baratinhaZ:', err);
        } finally {
          if (isActive) {
            setIsLoading(false);
          }
        }
      }

      fetchPodeResgatar();

      return () => {
        isActive = false;
      };
    }, []),
  );

  if (isLoading) {
    return null;
  }

  if (!resgate?.resgate_ativo) {
    return null;
  }

  return (
    <Container>
      <SectionHeader style={{marginBottom: RFValue(8)}}>
        <SectionTitleGroup style={{flex: 1}}>
          <Title style={{marginBottom: 0}}>Mais desconto</Title>
          <SectionSubtitle>BaratinhaZ</SectionSubtitle>
        </SectionTitleGroup>
        {Platform.OS !== 'web' && (
          <SectionBannerContainer>
            <BaratinhasDiscountBalloon />
          </SectionBannerContainer>
        )}
      </SectionHeader>
 <PaymentBaratinhasMethodItem
  usaBaratinhas={usaBaratinhas}
  descontoBaratinhas={descontoBaratinhas}
  handleAplicaBaratinhas={(value) => {
    analytics().logEvent('checkout_aplicou_baratinhas');
    handleAplicaBaratinhas(value);
  }}
  handleRemoveBaratinhas={() => {
    analytics().logEvent('checkout_removeu_baratinhas');
    handleRemoveBaratinhas();
  }}
  handleSetDescontoBaratinhas={handleSetDescontoBaratinhas}
  resgate={resgate}
  isLoading={false}
/>
      {!resgate?.pode_resgatar && resgate?.mensagem ? (
        <RescueHelperContainer>
          <Feather
            name="clock"
            size={RFValue(12)}
            color={theme.colors.alert_blue_icon}
          />
          <RescueHelperText>{resgate.mensagem}</RescueHelperText>
        </RescueHelperContainer>
      ) : null}
    </Container>
  );
}
